import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Right-Open">{props.title || 'Right-Open'}</title>
      <g>
        <path d="M408.3 232.3c6.4 6.3 9.7 13.9 9.7 22.4 0 8.6-3.2 16.2-9.7 22.5l-222.3 222.1c-6.4 6.3-13.8 9.6-22.3 9.6-8.4 0-15.9-3.2-22.3-9.6l-33.1-33.1c-6.4-6.5-9.6-13.9-9.6-22.4 0-8.5 3.2-15.9 9.6-22.3l168.1-168-168.2-166.2c-6.4-6.3-9.6-13.8-9.6-22s3.2-15.5 9.6-22l33.1-33.7c6.4-6.3 13.9-9.6 22.5-9.6s16 3.2 22.1 9.6l222.4 222.7z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/rightOpen.js